import { createAsyncThunk, createEntityAdapter, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { addShippingRulesApi, deleteShippingRulesApi, getShippingRulesApi, updateShippingRulesApi } from "../../../services/partners/settings/shippingRulesService";


export const getAllShippingRules = createAsyncThunk("partner/getAllShippingRules", async (filters, { dispatch }) => {
  const response = await getShippingRulesApi(filters);
  return response.response;
});

export const addShippingRules = createAsyncThunk("partner/addShippingRules", async (duration, { dispatch, getState }) => {
  try {
    const response = await addShippingRulesApi(duration);
    const data = await response.response;
    toast.success("Add Partner Shipping Rules successfully", {
      position: toast.POSITION.TOP_RIGHT,
    });
    return data;
  } catch (e) {
    return Promise.reject(e);
  }
});

export const updateShippingRules = createAsyncThunk("partner/updateShippingRules", async (duration, { dispatch, getStatus }) => {
  try {
    const response = await updateShippingRulesApi(duration, duration.id);
    const data = await response.response;
    toast.success("Update Shipping Rules successfully", {
      position: toast.POSITION.TOP_RIGHT,
    });
    return data;
  } catch (e) {
    return Promise.reject(e);
  }
});

export const deleteShippingRules = createAsyncThunk("partner/deleteShippingRules", async (id, { dispatch, getStatus }) => {
  try {
    const response = await deleteShippingRulesApi(id);
    const data = await response.response;
    toast.success("Deleted Shipping Rules successfully", {
      position: toast.POSITION.TOP_RIGHT,
    });
    return data;
  } catch (e) {
    return Promise.reject(e);
  }
});

const partnersShippingRulesAdapter = createEntityAdapter({});

export const { selectAll: selectShippingRules, selectById: selectShippingRulesId } = partnersShippingRulesAdapter.getSelectors(
  (state) => state.partner.partnerShippingRules
);

const shippingRulesSlice = createSlice({
  name: "partnerShippingRules",
  initialState: partnersShippingRulesAdapter.getInitialState({
    searchText: "",
    addDialog: {
      component: "PartnerShippingRules",
      type: "new",
      props: {
        open: false,
      },
      data: null,
    },
  }),
  reducers: {
    setPartnerShippingRulesSearchText: {
      reducer: (state, action) => {
        state.searchText = action.payload;
      },
      prepare: (event) => ({ payload: event.target.value || "" }),
    },
    openNewDialog: (state, action) => {
      state.addDialog = {
        component: "PartnerShippingRules",
        type: "new",
        props: {
          isOpen: true,
        },
        data: null,
      };
    },
    openEditDialog: (state, action) => {
      state.addDialog = {
        type: "edit",
        props: {
          isOpen: true,
        },
        data: action.payload,
      };
    },
    closeEditDialog: (state, action) => {
      state.addDialog = {
        type: "edit",
        props: {
          isOpen: false,
        },
        data: null,
      };
    },
  },
  extraReducers: {
    [getAllShippingRules.fulfilled]: partnersShippingRulesAdapter.setAll,
  },
});

export const { setPartnerShippingRulesSearchText, openNewDialog, closeNewDialog, openEditDialog, closeEditDialog } = shippingRulesSlice.actions;

export default shippingRulesSlice.reducer;
